// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2KILb","detailsBorder":"styles_detailsBorder__1Iuv3"};